import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import './FilterSidebar.css';

function FilterSidebar({ categories, colors, materials, pearlTypes, filters, onFilterChange, onClose }) {
  

  const handleCheckboxChange = (filterKey, value, isChecked) => {
    const newFilters = {
      ...filters,
      [filterKey]: [...(filters[filterKey] || [])]
    };
    
    if (isChecked) {
      // Ajouter la valeur si elle n'est pas déjà présente
      if (!newFilters[filterKey].includes(value)) {
        newFilters[filterKey].push(value);
      }
    } else {
      // Retirer la valeur
      const index = newFilters[filterKey].indexOf(value);
      if (index > -1) {
        newFilters[filterKey].splice(index, 1);
      }
    }
    
    onFilterChange(newFilters);
  };
  
  const removeFilter = (filterKey, value) => {
    handleCheckboxChange(filterKey, value, false);
  };

  const handleInputChange = (name, value) => {
    const newFilters = {
      ...filters,
      [name]: value
    };
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const initialFilters = {
      categories: [],
      colors: [],
      materials: [],
      pearlTypes: [],
      minPrice: '',
      maxPrice: ''
    };
    onFilterChange(initialFilters);
  };

  

  // Rendu d'un groupe de filtres avec sélection multiple
  const renderMultiSelect = (filterKey, label, options) => {
    const selectedValues = filters[filterKey] || [];
    
    return (
      <div className="filter-group" key={filterKey}>
        <label htmlFor={`${filterKey}-select`}>{label}</label>
        <select
          id={`${filterKey}-select`}
          value=""
          onChange={(e) => {
            if (e.target.value) {
              handleCheckboxChange(filterKey, e.target.value, true);
              e.target.value = ''; // Réinitialiser la sélection
            }
          }}
          className="multi-select"
        >
          <option value="">Sélectionner...</option>
          {options
            .filter(opt => !selectedValues.includes(opt.id))
            .map(opt => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
        </select>
        
        {/* Affichage des éléments sélectionnés */}
        {selectedValues.length > 0 && (
          <div className="selected-items">
            {selectedValues.map(value => {
              const item = options.find(opt => opt.id === value);
              return (
                <span key={value} className="selected-item">
                  {item?.name || value}
                  <button 
                    type="button" 
                    onClick={() => removeFilter(filterKey, value)}
                    className="remove-item"
                    aria-label={`Supprimer ${item?.name || value}`}
                  >
                    <FiX size={14} />
                  </button>
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <aside className="filter-sidebar">
      <div className="sidebar-header-mobile">
        <h3>Filtres</h3>
        <button onClick={onClose} className="close-sidebar-btn" aria-label="Fermer les filtres">
          <FiX size={20} />
        </button>
      </div>
      <h3 className="sidebar-header-desktop">Filtres</h3>

      {renderMultiSelect('categories', 'Catégories', categories)}
      {renderMultiSelect('colors', 'Couleurs', colors)}
      {renderMultiSelect('materials', 'Matières', materials)}
      {renderMultiSelect('pearlTypes', 'Types de perles', pearlTypes)}
      
      <div className="filter-group budget-filter-group">
        <label>Budget</label>
        <div className="budget-inputs">
          <div className="budget-input-wrapper">
            <input
              type="number"
              placeholder="Min"
              value={filters.minPrice || ''}
              onChange={(e) => handleInputChange('minPrice', e.target.value)}
              min="0"
              onWheel={(e) => e.target.blur()}
            />
            <span className="currency-symbol">€</span>
          </div>
          <span className="budget-separator">-</span>
          <div className="budget-input-wrapper">
            <input
              type="number"
              placeholder="Max"
              value={filters.maxPrice || ''}
              onChange={(e) => handleInputChange('maxPrice', e.target.value)}
              min={filters.minPrice || '0'}
              onWheel={(e) => e.target.blur()}
            />
            <span className="currency-symbol">€</span>
          </div>
        </div>
      </div>

      <div className="filter-actions">
        <button onClick={handleReset} className="reset-btn">
          Réinitialiser les filtres
        </button>
      </div>
    </aside>
  );
}

export default FilterSidebar;